import router from "@/router";
import { baseURL } from '@/ajax/index.js'

export function getAPPName() {
  // if(uni.getSystemInfoSync().platform == 'android'){
  // 	return '39游戏盒子'
  // }else{
  // 	return '39社区'
  // }
  if (typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent)) {
    return '39游戏盒子';
  }
  return appName; // 其他平台的默认名称
}

export async function getAgreementUrl() {
  return {
    user: baseURL + `/common/agreementInfo?type=user_agreement`,
    privacy: baseURL + `/common/agreementInfo?type=privacy_agreement`,
    register_agreement: baseURL + '/common/agreementInfo?type=register_agreement'
  }
}

export function navigateUrl(url) {
  // 判断是内页跳转还是外链跳转
  const urlLower = url.toLowerCase();
  const isExternalLink = urlLower.indexOf('http://') === 0 || urlLower.indexOf('https://') === 0;
  if (isExternalLink) {
    if (getDeviceType().isIOS) {
      window.location.href = url
    } else {
      window.open(url)
    }
  } else {
    router.push(url)
  }
}

// 检测是否为移动网络
export function isMobileNetwork() {
  return new Promise((resolve) => {
    if ('connection' in navigator) {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection) {
        const info = {
          type: connection.type, // 连接类型
          effectiveType: connection.effectiveType, // 网速等级
          downlink: connection.downlink, // 下行带宽
          rtt: connection.rtt, // 往返时间
          isMobile: ['cellular', 'bluetooth', 'wimax'].includes(connection.type)
        };

        console.log('网络信息:', info);
        resolve(info.isMobile);
        return;
      }
    }

    resolve(isMobile());
  });
}


/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}
function funisPCTrue() {
  var system = {
    win: false,
    mac: false,
    xll: false,
    ipad: false
  };
  //检测平台
  var p = navigator.platform;
  system.win = p.indexOf("Win") == 0;
  system.mac = p.indexOf("Mac") == 0;
  system.x11 = p == "X11" || p.indexOf("Linux") == 0;
  system.ipad = navigator.userAgent.match(/iPad/i) != null ? true : false;
  if (system.win || system.mac || system.xll || system.ipad) {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
}
// 判断设备类型
export function getDeviceType() {
  const ua = navigator.userAgent;
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isPad = /iPad/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isPC = !isAndroid && !isIOS && !isPad;
  // 
  const isPCTrue = funisPCTrue()
  
  return {
    isAndroid,
    isIOS,
    isPad,
    isPC,
    isMobile: isAndroid || isIOS || isPad,
    isPCTrue
  };
}

export function isMobile() {
  return getDeviceType().isMobile;
}
export function setrpx2Px(rpx) {
  return Math.round(rpx2Px(rpx));
}
export function appstyle() {
  let style = {}
  if (isMobile()) {
    style = {}
    style.width = "100%"
  } else {
    style = {
      maxWidth: "750px",
      margin: "0 auto"
    }
  }
  return style

}
//防抖
export const debounce = (fn, delay = 1000) => {
  let timerId;

  return function debouncedFn() {
    const context = this;
    const args = arguments;

    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(() => {
      fn.apply(context, args); // 这里应该是 fn(...arguments)  
    }, delay);
  };
};
// 节流
export const throttle = (fn, limit) => {
  let lastCall = 0;

  return function throttledFn() {
    const now = Date.now();
    if (now - lastCall < limit) {
      return;
    }
    lastCall = now;
    return fn.apply(this, arguments);
  };
};
/**
 * 格式化数量
 * @param {number} quantity 数量
 * @param {string} zeroValue 当数量为0的时候，返回的字符串
 * @returns {string} 格式化后的数量，例如"99"、"99万+"、"99亿+"
 * @example
 * formatQuantity(99)
 * // "99"
 * formatQuantity(9_0000)
 * // "9万"
 * formatQuantity(99_0001)
 * // "99万+"
 * formatQuantity(99_0000_0001)
 * // "99亿+"
 * formatQuantity(0, 'abcdefg')
 * // "abcdefg"
 */
export function formatQuantity(quantity, zeroValue) {
  if (quantity === 0) {
    return zeroValue ?? '0';
  }

  if (quantity >= 1_0000_0000) {
    return formatUnit(quantity, 1_0000_0000, '亿');
  } else if (quantity >= 1_0000) {
    return formatUnit(quantity, 1_0000, '万');
  }

  return String(quantity);
}

/**
 * 格式化单位
 * @param {number} number 需要格式化的数字
 * @param {number} dividend 单位的数值
 * @param {string} unit 单位的字符串
 * @returns {string}
 * @example
 * formatUnit(9_0000, 1_0000, '万')
 * // "9万"
 * formatUnit(99_0001, 1_0000, '万')
 * // "99万+"
 * formatUnit(99_0000_0001, 1_0000_0000, '亿')
 * // "99亿+"
 */
export function formatUnit(number, unitNumber, unitString) {
  const divi = number / unitNumber;
  const plus = hasDecimal(divi) ? '+' : '';
  return `${Math.floor(divi)}${unitString}${plus}`;
}
/**
 * 判断是否有小数
 * @param {number} num
 * @returns {boolean}
 */
export function hasDecimal(num) {
  return num % 1 !== 0;
}
// 截取
export function cutOut(url, name) {
  let value = ""
  try {
    value = url.split(name)[1].split("&")[0].split("=")[1];
  } catch (error) {

  }
  return value
}
export function initUrl(params) {
  // 动态插入脚本标签
  // const initUrl = process.env.VUE_APP_INIT;
  // const script = document.createElement('script');
  // script.type = 'text/javascript';
  // script.src = initUrl;
  // document.head.appendChild(script);
}

